import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { fetchCircuit } from "../../data/slices/circuitSlice";
import { alpha, Autocomplete, Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { COLORS, dateFormatter, output, priceFormatter, toEuro } from "../../settings/themeSettings";
import '../../index.scss';
import useIsAdmin from '../../hooks/useIsAdmin';



import { Stack } from '@mui/material';

import WestIcon from '@mui/icons-material/West';
import { CreditCard, Delete, Edit, PaymentsTwoTone } from '@mui/icons-material';
import { Card, CardContent, Grid, Divider } from '@mui/material';
import AddPaymentDialog from "../../components/AddPaymentDialog";
import { DateField, LocalizationProvider, frFR } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AjoutFraisDialog from "../../components/AjoutFraisDialog";
import { createFactureDossier, fetchFactureDossier, updateFactureDossier } from "../../data/slices/facturesDossierSlice";
import { notify } from "../../settings/toastSetting";
import dayjs from "dayjs";
import { isValid } from "date-fns";
import { useFormSaveHotkey } from "../../hooks/useHotkeys";



const styles = {
    container: {
        minHeight: '1000px',
        width: '1200px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.gray[100],
        padding: '15px',
        borderRadius: '5px',
        height: 'fit-content'

    },
    pathtitle: {
        fontSize: '1em',
        fontWeight: 'bold',
        padding: '0 10px',
        width: '100%',
        color: COLORS.tertiary
    },
    path: {
        width: '300px',
        height: '100%',
        //  border: '1px solid red'
    }
}






const FacturationDossier = (props) => {
    const { id, type, fid } = useParams();
    const dispatch = useDispatch();
    const isAdmin = useIsAdmin();

    const [loading, setLoading] = useState(false);
    const [loadingAjout, setLoadingAjout] = useState(false);
    const [facture, setFacture] = useState({});
    const [circuit, setCircuit] = useState({});
    const [bills, setBills] = useState([]);
    const [payments, setPayments] = useState([]);
    const [openAddBill, setOpenAddBill] = useState(false);
    const [openAddPayment, setOpenAddPayment] = useState(false);
    const navigateTo = useNavigate();
    const [totalFrais, setTotalFrais] = useState(0);
    const [totalPaiements, setTotalPaiements] = useState(0);
    const [editBillIndex, setEditBillIndex] = useState(null);
    const [editPaymentIndex, setEditPaymentIndex] = useState(null);

    const typeFactures = [{
        name: 'Facture d\'Avoir',
        code: 'AV'
    },
    {
        name: 'Facture Comptant',
        code: 'FC'

    },
    {
        name: 'Facture à Terme',
        code: 'FT'
    },
    {
        name: 'Facture Proforma',
        code: 'FP'
    }];

    const openAddPaymentDialog = (index = null) => {
        setEditPaymentIndex(typeof index === 'number' ? index : null);
        setOpenAddPayment(true);
    }
    const openAddBillDialog = (index = null) => {
        setEditBillIndex(typeof index === 'number' ? index : null);
        setOpenAddBill(true);
    }

    const handleAddBillClose = (data) => {
        setOpenAddBill(false);
        if (data) {
            if (editBillIndex !== null) {
                const _bills = [...bills];
                _bills[editBillIndex] = data.bill;
                setBills(_bills);
                setEditBillIndex(null);
            } else {
                if (data.bill) {
                    setBills([...bills, data.bill]);
                }
                if (data.payment) {
                  setPayments([...payments, data.payment]);
                }
            }
        } else {
            setEditBillIndex(null);
        }
    }

    const handleAddPaymentClose = (payment) => {
        setOpenAddPayment(false);
        if (payment) {
            if (editPaymentIndex !== null) {
                const _payments = [...payments];
                _payments[editPaymentIndex] = payment;
                setPayments(_payments);
                setEditPaymentIndex(null);
            } else {
                setPayments([...payments, payment]);
            }
        } else {
            setEditPaymentIndex(null);
        }
    }
    const removeBill = (id) => {
        const _bills = bills.filter((_, idx) => idx !== id);
        setBills(_bills);
    }


    const removePayment = (id) => {
        const _payments = payments.filter((_, idx) => idx !== id);
        setPayments(_payments);
    }
    useEffect(() => {





        setLoading(true);

        fetchCircuit(id)
            .then((response) => {
                const resp = response.data;

                if(fid){
                    output("we are editing!");
                    dispatch(fetchFactureDossier(fid)).unwrap()
                        .then((resp) => {
                            setFacture(resp);
                            setBills(resp.frais);
                            setPayments(resp.paiements);
                            setLoading(false);
                        })
                        .catch(err => {
                            output(err);
                            setLoading(false);
                        });
                }else{
                    setFacture({
                        date: dayjs(),
                        etat: 'En cours',
                        typeFacture: 'FC'
                    });
                    setLoading(false);
                }
                output(resp);
                setCircuit({...resp});
            })
            .catch(err => {
                setLoading(false);

                output(err);
            });


    }, [id, fid, type, navigateTo]);
    const saveFacture = () => {
        setLoadingAjout(true);

        const data = {
            ...facture,
            dossier: id,
            frais: bills,
            paiements: payments,
            date: isValid(facture.date) ? (dayjs.isDayjs(facture.date) ? facture.date.toISOString().split('T')[0] : facture.date) : facture.date
        };

        const action = fid ? updateFactureDossier({ ...data, id: fid }) : createFactureDossier(data);

        dispatch(action)
        .unwrap()
        .then((resp) => {
            setLoadingAjout(false);
            notify(fid ? "La facture a été mise à jour!" : "La facture a été ajoutée avec succès!", "success");
            navigateTo(`/dossiers/${type}/${id}/factures/${resp.id}`);
        })
        .catch((err) => {
            output(err);
            setLoadingAjout(false);
            const errorMsg = err?.response?.data?.detail || err?.message || "Une erreur s'est produite!";
            notify(errorMsg, "error");
        });
    };

    // Raccourci global Ctrl+S pour enregistrer la facture dossier
    useFormSaveHotkey(saveFacture, !loadingAjout);

    useEffect(() => {
        const newTotalFrais = bills.reduce((total, current) => {
            const montantLigne = current.currency === 'EURO'
                ? Number(current.prixUnitaire * 655.957 * current.quantite)
                : Number(current.prixUnitaire * current.quantite);
            return { montant: Number(total.montant) + montantLigne };
        }, { montant: 0 }).montant;

        const newTotalPaiements = payments.reduce((total, current) => {
            return { montant: Number(total.montant) + Number(current.montant) };
        }, { montant: 0 }).montant;
        setTotalFrais(newTotalFrais);
        setTotalPaiements(newTotalPaiements);
    }, [bills, payments]);



    return <>

        {loading ?
            <div className="loader-container">
                <span className="loader"></span>
            </div>

            :



            <div className='details-circuit-container' >

                <LocalizationProvider dateAdapter={AdapterDayjs} localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
                >


                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        gap="15"
                        alignItems="flex-start"

                    >
                        <div onClick={() => navigateTo(`/dossiers/${type}/${id}`)}
                            style={{ background: COLORS.secondary, height: '65px', width: '65px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: `${65 / 2}px`, cursor: 'pointer' }}>
                            <WestIcon style={{ fill: 'white', fontSize: 28 }} />
                        </div>
                        <Typography variant="h4" sx={{ backgroundColor: COLORS.secondary, color: '#FFF', p: '10px', mb: 5, width: '100%', ml: 2 }}>Facturation {type} </Typography>

                    </Stack>


                    <Card sx={{ mb: 4, boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                        <CardContent>
                            <Typography variant="h6" sx={{ color: COLORS.tertiary, mb: 3, fontWeight: 'bold' }}>
                                Informations du {type}
                            </Typography>
                            
                            <Grid container spacing={4}>
                                {/* Colonne 1 : Références principales */}
                                <Grid item xs={12} md={4}>
                                    <Stack spacing={2}>
                                        <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                            <span style={{ color: COLORS.tertiary }}>Réference :</span>
                                            <span style={{ fontWeight: "bold", color: COLORS.secondary }}>{circuit.reference}</span>
                                        </Typography>

                                        { (type === 'transfert') && (
                                            <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                                <span style={{ color: COLORS.tertiary }}>Nom client :</span>
                                                <span style={{ fontWeight: "bold", color: COLORS.secondary }}>{circuit.nomClient}</span>
                                            </Typography>
                                        )}

                                        {(type !== 'sejour' && type !== 'transfert') && (
                                            <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                                <span style={{ color: COLORS.tertiary }}>Programme :</span>
                                                <span style={{ fontWeight: "bold", color: COLORS.secondary }}>{circuit.programme?.libelle}</span>
                                            </Typography>
                                        )}
                                        
                                        <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                            <span style={{ color: COLORS.tertiary }}>TO / Client :</span>
                                            <span style={{ fontWeight: "bold", color: COLORS.secondary }}>{circuit.toClient?.libelle}</span>
                                        </Typography>
                                    </Stack>
                                </Grid>

                                {/* Colonne 2 : Intervenants et logistique */}
                                <Grid item xs={12} md={4}>
                                    <Stack spacing={2}>
                                        <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                            <span style={{ color: COLORS.tertiary }}>Chauffeur :</span>
                                            <span style={{ fontWeight: "bold", color: COLORS.secondary }}>{circuit?.chauffeur?.nomComplet}</span>
                                        </Typography>
                                        
                                        <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                            <span style={{ color: COLORS.tertiary }}>Guide :</span>
                                            <span style={{ fontWeight: "bold", color: COLORS.secondary }}>{circuit?.guide?.nomComplet}</span>
                                        </Typography>
                                        
                                        <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                            <span style={{ color: COLORS.tertiary }}>Véhicule :</span>
                                            <span style={{ fontWeight: "bold", color: COLORS.secondary }}>{circuit?.vehicule?.modele}</span>
                                        </Typography>

                                        {(type === 'circuit' || type === 'sejour') && (
                                            <>
                                                <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                                    <span style={{ color: COLORS.tertiary }}>Vol Arrivée :</span>
                                                    <span style={{ fontWeight: "bold", color: COLORS.secondary, fontSize: '0.9em' }}>
                                                        {dateFormatter(circuit?.dateVolArrivee)} {circuit?.heureVolArrivee ? '- ' + (new Date(circuit?.heureVolArrivee)).toTimeString().split(' ')[0] : ''}
                                                    </span>
                                                </Typography>
                                                <Typography sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 1 }}>
                                                    <span style={{ color: COLORS.tertiary }}>Vol Départ :</span>
                                                    <span style={{ fontWeight: "bold", color: COLORS.secondary, fontSize: '0.9em' }}>
                                                        {dateFormatter(circuit?.dateVolDepart)} {circuit?.heureVolDepart ? '- ' + (new Date(circuit?.heureVolDepart)).toTimeString().split(' ')[0] : ''}
                                                    </span>
                                                </Typography>
                                            </>
                                        )}
                                    </Stack>
                                </Grid>

                                {/* Colonne 3 : Facturation */}
                                <Grid item xs={12} md={4}>
                                    <Stack spacing={2} sx={{ backgroundColor: alpha(COLORS.secondary, 0.05), p: 2, borderRadius: 1 }}>
                                        <Typography sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span style={{ color: COLORS.tertiary }}>Montant Prévu :</span>
                                            <span style={{ fontWeight: "bold", color: COLORS.secondary }}>
                                                {priceFormatter(circuit?.frais?.reduce((sum, frai) => ({ montant: sum.montant + frai.montant }), { montant: 0 }).montant)}
                                            </span>
                                        </Typography>
                                        
                                        <Typography sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ color: COLORS.tertiary, marginBottom: '4px' }}>Commentaire du circuit :</span>
                                            <span style={{ fontWeight: "bold", color: COLORS.secondary, fontSize: '0.9em', whiteSpace: 'pre-line' }}>
                                                {circuit.commentaire || 'Aucun commentaire'}
                                            </span>
                                        </Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <Card sx={{ mb: 4, boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                        <CardContent>
                            <Typography variant="h6" sx={{ color: COLORS.tertiary, mb: 3, fontWeight: 'bold' }}>
                                Propriétés de la Facture
                            </Typography>
                            
                            <Grid container spacing={3} alignItems="center">
                                <Grid item xs={12} md={3}>
                                    <DateField
                                        label="Date de la facture"
                                        color="secondary"
                                        focused
                                        fullWidth
                                        InputProps={{ style: { height: '45px' } }}
                                        format="DD-MM-YYYY"
                                        value={facture?.date ? dayjs(facture.date) : null}
                                        onChange={(e) => { setFacture({ ...facture, date: e }) }}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        value={facture ? (typeFactures.find((f) => f.code === facture?.typeFacture) || null) : null}
                                        onChange={(event, option) => {
                                            setFacture({ ...facture, typeFacture: option?.code || 'FC' });
                                        }}
                                        options={typeFactures}
                                        getOptionLabel={(option) => option.name}
                                        color="secondary"
                                        renderInput={(params) => <TextField {...params} label="Type de facture" sx={{ '.MuiInputBase-root': { height: '45px' } }} />}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        value={facture?.etat || 'En cours'}
                                        onInputChange={(event, newInputValue) => {
                                            setFacture({ ...facture, etat: newInputValue || 'En cours' });
                                        }}
                                        onChange={(event, option) => {
                                            setFacture({ ...facture, etat: option || 'En cours' });
                                        }}
                                        options={['En cours', 'Clôturée', "Annulée"]}
                                        color="secondary"
                                        renderInput={(params) => <TextField {...params} label="Etat de la facture" sx={{ '.MuiInputBase-root': { height: '45px' } }} />}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        fullWidth
                                        name="Commentaire"
                                        label="Commentaire de facturation"
                                        InputProps={{ style: { height: '45px' } }}
                                        color="secondary"
                                        focused
                                        value={facture?.commentaire || ''}
                                        onChange={(e) => { setFacture({ ...facture, commentaire: e.target.value }) }}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>




                    <Grid container spacing={4} sx={{ mb: 4 }}>
                        <Grid item xs={12} md={6}>
                            {/* Summary Totals above the table */}
                            <Stack 
                                direction="row" 
                                spacing={4} 
                                sx={{ 
                                    mb: 2, 
                                    p: 2, 
                                    bgcolor: alpha(COLORS.secondary, 0.05), 
                                    borderRadius: 1,
                                    border: `1px solid ${alpha(COLORS.secondary, 0.2)}`,
                                    justifyContent: 'space-around'
                                }}
                            >
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ color: COLORS.secondary, fontWeight: 'bold', textTransform: 'uppercase' }}>Total Facture</Typography>
                                    <Typography variant="h6" sx={{ color: COLORS.secondary }}>{priceFormatter(totalFrais)}</Typography>
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ color: COLORS.primary, fontWeight: 'bold', textTransform: 'uppercase' }}>Total Réglement</Typography>
                                    <Typography variant="h6" sx={{ color: COLORS.primary }}>{priceFormatter(totalPaiements)}</Typography>
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ color: (totalFrais - totalPaiements) > 0 ? 'error.main' : 'success.main', fontWeight: 'bold', textTransform: 'uppercase' }}>Solde</Typography>
                                    <Typography variant="h6" sx={{ color: (totalFrais - totalPaiements) > 0 ? 'error.main' : 'success.main' }}>{priceFormatter(totalFrais - totalPaiements)}</Typography>
                                </Box>
                            </Stack>


                            <TableContainer component={Paper} >
                                <Table sx={{ minWidth: 450 }} aria-label="simple table" >
                                    <TableHead >
                                        <TableRow sx={{ border: `1px solid ${COLORS.secondary}` }}>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Prestation</TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Nombre</TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>P.U</TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Devise</TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Montant (CFA)</TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Montant (EURO)</TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}> <Delete /> </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>


                                        {
                                            bills.map((bill, idx) => (
                                                <TableRow key={idx} sx={{ color: COLORS.secondary, border: `1px solid ${COLORS.secondary}`, '& > *': { border: `1px solid ${COLORS.secondary}` } }}>
                                                    <TableCell>{bill.designation}</TableCell>
                                                    <TableCell>{bill.quantite}</TableCell>
                                                    <TableCell>{priceFormatter(bill.prixUnitaire)}</TableCell>
                                                    <TableCell>{bill.currency || 'CFA'}</TableCell>
                                                    <TableCell>{bill.currency === 'EURO' ? priceFormatter(bill.prixUnitaire * 655.957 * bill.quantite) : priceFormatter(bill.prixUnitaire * bill.quantite)}</TableCell>
                                                    <TableCell>{bill.currency === 'EURO' ? (bill.prixUnitaire * bill.quantite).toFixed(2) : toEuro(bill.prixUnitaire * bill.quantite)}</TableCell>
                                                    <TableCell sx={{ minWidth: '80px' }}>
                                                        {isAdmin && <>
                                                            <Edit style={{ fill: COLORS.primary, cursor: 'pointer', marginRight: 10 }} onClick={() => openAddBillDialog(idx)} />
                                                            <Delete style={{ fill: 'red', cursor: 'pointer' }} onClick={() => removeBill(idx)} />
                                                        </>}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }


                                    </TableBody>
                                </Table>
                            </TableContainer>





                            <Button
                                variant="outlined"
                                color="secondary"
                                startIcon={<PaymentsTwoTone sx={{ fill: COLORS.secondary }} />}
                                onClick={openAddBillDialog}
                            >
                                Ajouter prestations
                            </Button>
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>



                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 450 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow sx={{ border: `1px solid ${COLORS.secondary}` }}>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Mode de paiement</TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}> Montant (CFA) </TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}> Montant (EURO) </TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Date </TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Commentaire </TableCell>
                                            <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}> <Delete /> </TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            payments.map((payment, idx) => {
                                                return <TableRow key={idx} sx={{ color: COLORS.secondary, '& > *': { border: `1px solid ${COLORS.secondary}` } }}>

                                                    <TableCell> {payment.methode} </TableCell>
                                                    <TableCell> {priceFormatter(payment.montant) } </TableCell>
                                                    <TableCell> {toEuro(payment.montant || 0) } </TableCell>
                                                    <TableCell> {dateFormatter(payment.date)} </TableCell>
                                                    <TableCell> {payment.commentaire} </TableCell>
                                                    <TableCell sx={{ minWidth: '80px' }}>
                                                        {isAdmin && <>
                                                            <Edit style={{ fill: COLORS.primary, cursor: 'pointer', marginRight: 10 }} onClick={() => openAddPaymentDialog(idx)} />
                                                            <Delete style={{ fill: 'red', cursor: 'pointer' }} onClick={() => removePayment(idx)} />
                                                        </>}
                                                    </TableCell>


                                                </TableRow> 

                                            })
                                        }


                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Button
                                variant="outlined"
                                color="secondary"
                                startIcon={<CreditCard sx={{ fill: COLORS.secondary }} />}
                                onClick={openAddPaymentDialog}
                            >
                                Ajouter un réglement
                            </Button>


                        </Box>
                    </Grid>
                    </Grid>

                    <Divider sx={{ my: 4 }} />







                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                        sx={{
                            mt: 4,
                            mb: 4,
                            pb: 5
                        }}

                    >


                        <Button
                            variant="contained"
                            color="primary"
                            style={{ color: 'white' }}
                            onClick={() => navigateTo(`/dossiers/${type}/${id}/factures`)}
                        >
                            {loading ? 'Patientez..' : 'FERMER'}
                            
                        </Button>
                        <Button
                            variant="contained"
                            onClick={saveFacture}
                            sx={{
                                backgroundColor: COLORS.secondary,
                                '&:hover': {
                                    backgroundColor: alpha(COLORS.secondary, 0.8),
                                },
                                width: '100%',
                                height: '50px',
                                fontSize: '1.2em',
                                fontWeight: 'bold',
                            }}
                            disabled={loadingAjout}
                        >
                            {loadingAjout ? "Enregistrement..." : fid ? "Mettre à jour la facture" : "Enregistrer la facture"}
                        </Button>

                    </Stack>
                </LocalizationProvider>

            </div>
        }
        <AjoutFraisDialog 
            open={openAddBill} 
            onClose={handleAddBillClose} 
            isEditMode={editBillIndex !== null} 
            initialData={editBillIndex !== null ? bills[editBillIndex] : null} 
        />
        <AddPaymentDialog 
            open={openAddPayment} 
            onClose={handleAddPaymentClose} 
            isComptant={facture?.typeFacture === 'FC'} 
            isEditMode={editPaymentIndex !== null} 
            initialData={editPaymentIndex !== null ? payments[editPaymentIndex] : null} 
        />
    </>;

}


export default FacturationDossier;
